module.exports = __webpack_public_path__ + "img/ideas.d07d4aed.png";